import React from "react";
import { useCartContext } from "~hooks";
import cn from "classnames";
import { DISCOUNT_TIERS } from "~constants/discounts";
import * as styles from "./styles.module.scss";

const UpsellHintText = ({ className, quantityToAdd }) => {
  const { getCartDiscountPercentage, numberOfItemsInCart } = useCartContext();

  const maximumDiscountPercentage =
    DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1].discountPercentage;

  if (numberOfItemsInCart >= 3) {
    return (
      <p className={cn(`caption`, className)}>
        You are saving{` `}
        <span className={styles.maximumPercentage}>
          {maximumDiscountPercentage}%
        </span>
        {` `}
        on your total!
      </p>
    );
  }

  // On PDP
  if (quantityToAdd) {
    const cartAndQuantityToAdd = numberOfItemsInCart + quantityToAdd;

    const discountPercentage = getCartDiscountPercentage(
      Math.max(2, cartAndQuantityToAdd)
    );

    if (cartAndQuantityToAdd === 1) {
      return (
        <p className={cn(`caption`, className)}>
          Add 2 or more items to cart and save on your total!
        </p>
      );
    }

    return (
      <p className={cn(`caption`, className)}>
        Add to cart and save{` `}
        <span
          className={cn({
            [styles.maximumPercentage]:
              discountPercentage === maximumDiscountPercentage
          })}
        >
          {discountPercentage}%
        </span>
        {` `}
        on your total!
      </p>
    );
  }

  // In cart
  const nextTierDiscountPercentage = getCartDiscountPercentage(
    numberOfItemsInCart + 1
  );

  if (numberOfItemsInCart < 3) {
    return (
      <p className={cn(`caption`, className)}>
        Add another item to save{` `}
        <span
          className={cn({
            [styles.maximumPercentage]:
              nextTierDiscountPercentage === maximumDiscountPercentage
          })}
        >
          {nextTierDiscountPercentage}%
        </span>
      </p>
    );
  }

  return null;
};

export default UpsellHintText;
